import useEmblaCarousel from "embla-carousel-react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import SeasonCard from "./SeasonCard";
import { usePrevNextButtons } from "./hooks";

const SeasonCarousel = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    align: "center",
    direction: "rtl",
  });
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  const slides = [
    {
      chapterId: 6,
      season: "فصل اول",
      subtitle: "صدا سازی چیست؟",
      description: "چرا صدا سازی الزامیست؟",
    },
    {
      chapterId: 7,
      season: "فصل دوم",
      subtitle: "آشنایی با متد صداسازی CVT",
      description: "متد CVT چیست و چه کاربردی دارد؟",
    },
    {
      chapterId: 8,
      season: "فصل سوم",
      subtitle: "تمارین مختصر و کاربردی",
      description: "تمرین‌هایی برای بهبود و کنترل صدا.",
    },
  ];

  return (
    <section className="w-full [--slide-height:19rem] [--slide-size:100%]">
      <div className="overflow-hidden relative" ref={emblaRef}>
        <div className="flex touch-pan-y touch-pinch-zoom ml-[calc(var(--slide-spacing,0rem)*-1)]">
          {slides.map((slide) => (
            <div
              key={slide.chapterId}
              className="transform-gpu min-w-0 flex-[0_0_var(--slide-size)] sm:flex-[0_0_50%] md:flex-[0_0_50%] lg:flex-[0_0_40%] xl:flex-[0_0_33%] flex items-center justify-center"
            >
              <div className="flex flex-col items-center justify-center mx-auto gap-4 w-[75%] sm:w-[90%]">
                <h3 className="font-kalameh text-5xl text-white">
                  {slide.season}
                </h3>
                <div className="text-center">
                  <p className="font-kalameh text-white">{slide.subtitle}</p>
                  <p className="font-kalameh text-white">{slide.description}</p>
                </div>
                <SeasonCard chapterId={slide.chapterId} />
              </div>
            </div>
          ))}
        </div>
        <button
          className="visible sm:hidden size-11 absolute top-64 right-0"
          onClick={onPrevButtonClick}
          disabled={prevBtnDisabled}
        >
          <FiArrowRight
            className={`text-4xl font w-full ${
              prevBtnDisabled ? "text-white/35" : "text-white"
            }`}
          />
        </button>
        <button
          className="visible sm:hidden size-11 absolute top-64 left-0"
          onClick={onNextButtonClick}
          disabled={nextBtnDisabled}
        >
          <FiArrowLeft
            className={`text-4xl font w-full ${
              nextBtnDisabled ? "text-white/35" : "text-white"
            }`}
          />
        </button>
      </div>
    </section>
  );
};

export default SeasonCarousel;
